import { render, staticRenderFns } from "./blogList.vue?vue&type=template&id=5c83182f&scoped=true&"
import script from "./blogList.vue?vue&type=script&lang=js&"
export * from "./blogList.vue?vue&type=script&lang=js&"
import style0 from "./blogList.vue?vue&type=style&index=0&id=5c83182f&lang=scss&scoped=true&"
import style1 from "./blogList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c83182f",
  null
  
)

export default component.exports